import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { useAuth } from '../../contexts/AuthContext'
import { ADMIN_NAV } from './adminNav'
import { IconLabel } from '../icons'

function isActive(pathname, itemPath) {
  if (itemPath === '/admin') return pathname === '/admin'
  return pathname === itemPath || pathname.startsWith(`${itemPath}/`)
}

export default function AdminSidebar() {
  const location = useLocation()
  const navigate = useNavigate()
  const { logout } = useAuth()
  const [badges, setBadges] = useState({})

  const handleLogout = () => {
    logout()
    navigate('/login')
  }

  useEffect(() => {
    const loadBadges = () => {
      axios
        .get('/api/admin/dashboard-stats')
        .then((r) => {
          setBadges({
            pending_registrations: r.data.pending_registrations,
            pending_payment_orders: r.data.pending_payment_orders,
            pending_compliance:
              (r.data.pending_email_requests || 0)
              + (r.data.pending_escrow_events || 0)
              + (r.data.pending_payment_orders || 0),
          })
        })
        .catch(() => {})
    }
    loadBadges()
    const id = setInterval(loadBadges, 30000)
    window.addEventListener('rs-admin-badges-changed', loadBadges)
    return () => {
      clearInterval(id)
      window.removeEventListener('rs-admin-badges-changed', loadBadges)
    }
  }, [])

  return (
    <aside className="admin-sidebar scrollbar-sidebar">
      <div className="admin-sidebar-logo">
        <h1>
          Rotation<span>Street</span>
        </h1>
        <span className="admin-role">/ Admin</span>
      </div>
      <div className="admin-nav-divider" />
      {ADMIN_NAV.map((item, idx) => {
        if (item.type === 'divider') {
          return <div key={`d-${idx}`} className="admin-nav-divider" />
        }
        const active = isActive(location.pathname, item.path)
        const badge = item.badgeKey ? badges[item.badgeKey] : null
        const badgeCount = Number(badge) || 0
        const className = [
          'admin-nav-item',
          active ? 'active' : '',
          item.twoLine ? 'admin-nav-item--two-line' : '',
        ].filter(Boolean).join(' ')
        return (
          <Link key={item.path} to={item.path} className={className}>
            {item.icon ? <IconLabel name={item.icon}>{item.label}</IconLabel> : item.label}
            {item.badgeKey && (
              <span
                className={`admin-nav-badge${badgeCount > 0 ? '' : ' is-empty'}`}
                aria-hidden={badgeCount <= 0}
              >
                {badgeCount > 0 ? badgeCount : 0}
              </span>
            )}
          </Link>
        )
      })}
      <div className="admin-nav-divider" />
      <button type="button" className="admin-nav-item admin-nav-logout" onClick={handleLogout}>
        <IconLabel name="logout" size="sm">Log Out</IconLabel>
      </button>
    </aside>
  )
}
